export const ENDPOINTS = {
    commonData: {
        fetchCountries: 'api/common/countries',
        fetchStates: 'api/common/states',
        fetchFundTypes: 'api/common/fundTypes',
        fileWithState: 'api/filings/fileWithState?filingId=',
        fetchfundFilingTypes: 'api/common/fundFilingTypes',
        fetchRenewalCycleTypes: 'api/common/renewalCycleTypes',
        fetchPaymentTypes: 'api/common/paymentTypes',
        fetchPermitNumberTypes: 'api/common/permitNumberTypes',
        fetchMailingMethodTypes: 'api/common/mailingMethodTypes'
    },
    employee: {
        clientInformation: {
            fetchClientList: 'api/client/',
            seacrhClientByKeyword: 'api/client/search/',
            addNewClient: 'api/client',
            fetchAllClient: 'api/clients',
            fetchClientsByAccount: 'api/clients/'
        },
        trust: {
            fetchTrust: 'api/trust/',
            fetchTrustFilings: 'api/filings/byTrust/',
            fetchTrustByClient: 'api/trusts/byClient/',
            fetchTrustHistory: 'api/trust/getHistory/',
            fetchTrustStates: 'api/trust/getStates/',
            addEditNewTrust: 'api/trust'
        },
        portfolio: {
            fetchPortfolio: 'api/portfolio/',
            fetchPortfolioFilings: 'api/filings/byPortfolio/',
            fetchPortfolioHistory: 'api/portfolio/getHistory/',
            fetchPortfolioStates: 'api/portfolio/getStates/',
            fetchPortfolioByTrust: 'api/portfolios/byTrust/',
            addEditNewPortfolio: 'api/portfolio'
        },
        classes: {
            fetchClass: 'api/class/',
            searchClasses: 'api/class/search/',
            fetchClassFilings: 'api/filings/byClass/',
            fetchClassHistory: 'api/class/getHistory/',
            fetchClassStates: 'api/class/getStates/',
            fetchClassesByPortfolio: 'api/classes/byPortfolio/',
            addEditNewClass: 'api/class'
        },
        prospectus: {
            fetchProspectusData: 'api/prospectus/',
            fetchProspectusFilings: 'api/filings/byProspectus/',
            fetchProspectusHistory: 'api/prospectus/getHistory/',
            fetchProspectusStates: 'api/prospectus/getStates/',
            fetchProspectusByClient: 'api/prospectuses/byClient/',
            seacrhProspectusByKeyword: 'api/prospectus/search/',
            addOrEditNewProspectus: 'api/prospectus'
        },
        filing: {
            fetchFilings: 'api/filing/',
            fetchPendingFilings: 'api/filings/pending',
            fetchCancelledFilings: 'api/filings/cancelled',
            fetchRecentExemptedFilings: 'api/filings/recentExempted',
            fetchPendingAmendments: 'api/filings/pendingAmendments',
            fetchFilingsByEffectiveDate: 'api/filingsByEffectiveDate',
            fetchFilingsReadyForRenewal: 'api/filings/readyForRenewal/',
            fetchTerminatedFilings: 'api/filings/terminated/',
            fetchEverActiveFilings: 'api/filings/everActive/',
            fetchFilingsByFileByDate: 'api/filingsByFileByDate',
            filingsAllActive: 'api/filingsAllActive/',
            submitNewFiling: 'api/filings/submitNewFiling',
            submitNewFilings: 'api/filings/submitNewFilings',
            updateFiling: 'api/updateFiling/',
            changeFilingStatus: 'api/changeFilingStatus/',
            changeFilingListStatus: 'api/changeFilingStatus?filingStatus='
        },
        sales: {
            fetchSales: 'api/sales/salesData',
            fetchAdminSales: 'api/sales/adminSalesData'
        },
        security: {
            pendingTrusts: 'api/trust/pending/',
            pendingPortfolios: 'api/portfolio/pending/',
            pendingClasses: 'api/class/pending/'
        },
        user: {
            fetchUsers: 'api/identity/getUsers',
            fetchUser: 'api/identity/getUser/',
            addNewUser: 'api/identity/createUser',
            updateUser: 'api/identity/updateUser'
        },
        role: {
            fetchRoles: 'api/identity/getRoles'
        },
        account: {
            fetchAccounts: 'api/accounts'
        },
        state: {
            fetchStates: 'api/states',
            fetchState: 'api/state/',
            addNewState: 'api/state'
        }
    },
    authentication: {
        login: 'api/identity/loginUser',
        logout: 'api/identity/logoutUser'
    }
};



// WEBPACK FOOTER //
// ./src/services/constant/endpoints.js